import { tUnchecked } from '@glow/language'
import i18next from 'i18next'
import { ButtonBase, Card, IconFa, PlainButton, Text } from '../../atoms'
import type { IconProp } from '../../atoms/icon'
import styles from './index.module.css'

export interface NotificationCardProps {
  open: boolean
  onClose: () => void
  titleI18n: string
  descriptionI18n?: string
  primaryOnClick?: () => void
  primaryButtonI18n?: string
  secondaryButtonI18n?: string
  faIcon?: IconProp
}

export const NotificationCard = ({
  open,
  onClose,
  titleI18n,
  descriptionI18n,
  primaryOnClick,
  primaryButtonI18n,
  secondaryButtonI18n,
  faIcon
}: NotificationCardProps) => {
  return open ? (
    <Card className={styles['notification-card']}>
      <div className="flex justify-end -mt-2">
        <PlainButton
          type="button"
          onClick={onClose}
          className="h-8 w-8 min-w-8 rounded-xs text-xl"
          aria-label={i18next.t('glow.close')}
        >
          <IconFa icon={['fas', 'close']} />
        </PlainButton>
      </div>
      <Text as="p" textType="lg">
        {faIcon && <IconFa icon={faIcon} className="mr-2" />}
        {tUnchecked(titleI18n)}
      </Text>
      {descriptionI18n && (
        <Text className="mt-2" as="p" textType="base">
          {tUnchecked(descriptionI18n)}
        </Text>
      )}
      <div className="mt-6 flex gap-4 justify-end">
        <ButtonBase onClick={onClose} variant={'secondary'}>
          {tUnchecked(secondaryButtonI18n ?? 'glow.dismiss')}
        </ButtonBase>
        {primaryOnClick && primaryButtonI18n && (
          <ButtonBase variant="primary" onClick={primaryOnClick}>
            {tUnchecked(primaryButtonI18n)}
          </ButtonBase>
        )}
      </div>
    </Card>
  ) : null
}
